import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '@env';

export interface IdentityResponse {
  readonly keycloakUserId: string;
  readonly displayName: string;
  readonly email: string;
  readonly role: string;
  readonly organizations?: string[];
}

@Injectable({ providedIn: 'root' })
export class IdentityApiService {
  private readonly http = inject(HttpClient);

  getCurrentUser(): Promise<IdentityResponse> {
    return firstValueFrom(this.http.get<IdentityResponse>(`${environment.apiUrl}/identity/me`));
  }
}
